export enum ECheckoutTypes {
  SPLIT_BY_AMOUNT = 'split_by_amount',
  DEFAULT = 'default',
}
